import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Contact: React.FC = () => (
  <Box sx={{ p: 3, maxWidth: 800, mx: 'auto', mt: 10 }}>
    <Typography variant="h3" gutterBottom>Contact</Typography>
    <Typography paragraph>Trait Indicator</Typography>
    <Typography paragraph>Email: <Link href="mailto:info@traitindicator.com">info@traitindicator.com</Link></Typography>
  </Box>
);

export default Contact;
